import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../modules/auth/services/auth/auth.service';
import {
  persistCpInviteToken,
  readCpInviteTokenFromUrl,
} from '../../utils/cp-invite-session.util';

function resolveInviteToken(route: ActivatedRouteSnapshot): string | null {
  const fromRoute =
    route.queryParamMap.get('inviteToken')?.trim() ??
    route.firstChild?.queryParamMap.get('inviteToken')?.trim() ??
    null;
  if (fromRoute) {
    return fromRoute;
  }
  if (typeof window !== 'undefined') {
    return readCpInviteTokenFromUrl(window.location.href);
  }
  return null;
}

/**
 * Auth screens (login/register). An active portal session redirects to dashboard.
 * Invite links must always open registration — clear any existing portal session first.
 */
export const noAuthGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const inviteToken = resolveInviteToken(route);
  if (inviteToken) {
    persistCpInviteToken(inviteToken);
  }

  if (authService.isAuthenticated()) {
    if (inviteToken) {
      authService.clearPortalSession();
      authService.clearOnboardingSession();
      return true;
    }

    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
